import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import NumberFlow from '@number-flow/react';

export const AboutUs: React.FC = () => {
  const statsRef = useRef<HTMLDivElement>(null);
  const statsInView = useInView(statsRef, { once: true, margin: '-80px' });

  return (
    <section className="py-24 bg-white border-t border-slate-200 relative">
      {/* Full height vertical lines at container edges */}
      <div className="absolute inset-0 max-w-7xl mx-auto pointer-events-none">
        <div className="absolute left-0 top-0 bottom-0 w-px bg-slate-200"></div>
        <div className="absolute right-0 top-0 bottom-0 w-px bg-slate-200"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-4xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-6xl text-slate-900 mb-8 leading-tight">
              Healthcare should be <br />
              <span className="text-[#003b82]">accessible to everyone.</span>
            </h2>
            <p className="text-xl md:text-2xl text-slate-500 leading-relaxed font-light">
              We believe that quality medical guidance shouldn't be a luxury. Our mission is to democratize healthcare access through advanced technology, making it easier for everyone to understand their health: instantly, privately, and securely.
            </p>
          </motion.div>

          <div ref={statsRef} className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center border-t border-slate-100 pt-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <h3 className="text-5xl font-bold text-[#003b82] mb-2">
                <NumberFlow value={statsInView ? 24 : 0} suffix="/7" />
              </h3>
              <p className="text-slate-500 font-medium">Always Available</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <h3 className="text-5xl font-bold text-[#003b82] mb-2">
                <NumberFlow value={statsInView ? 100 : 0} suffix="%" />
              </h3>
              <p className="text-slate-500 font-medium">Private & Secure</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
            >
              <h3 className="text-5xl font-bold text-[#003b82] mb-2">
                <NumberFlow value={statsInView ? 0 : 60} suffix="s" />
              </h3>
              <p className="text-slate-500 font-medium">Wait Time</p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
